import { INSTRUCTION_DESTINATION_MAX_LENGTH } from '@/components/constants';
import { InstructionPdfForm } from '@/features/ap_payees/components/DocInstructionMenu/types';
import { useTranslation } from '@/i18n';
import { FormTextArea, Label } from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';
import { Control } from 'react-hook-form';
import styles from '../styles.module.scss';
import { validationRules } from '@/features/ap_payees/components/DocInstructionMenu/Helpers/validationRules';

export type TInstructionDestinationProps = {
  control: Control<InstructionPdfForm>;
};

export const InstructionDestination: FC<TInstructionDestinationProps> = memo(
  ({ control }) => {
    const { t } = useTranslation();

    const destinationRules = useMemo(
      () => ({
        required: {
          value: true,
          message: t('common.validation.required'),
        },
        validate: validationRules.requiredNotAllowEmpty(
          t('common.validation.required')
        ),
        maxLength: {
          value: INSTRUCTION_DESTINATION_MAX_LENGTH,
          message: t('common.validation.max_length', {
            maxLength: INSTRUCTION_DESTINATION_MAX_LENGTH,
          }),
        },
      }),
      [t]
    );

    const destinationProps = useMemo(
      () => ({
        style: {
          height: '72px',
          minHeight: '72px',
        },
        'data-testid': 'destination',
      }),
      []
    );

    return (
      <div className={styles.row}>
        <div className={styles.label}>
          <Label
            text={t('export_instruction_pdf_destination')}
            htmlFor='destination'
            data-testid='destination-label'
          />
        </div>
        <div className={styles.content}>
          <FormTextArea<InstructionPdfForm>
            name='destination'
            textAreaProps={destinationProps}
            control={control}
            inputId='destination'
            rules={destinationRules}
          />
        </div>
      </div>
    );
  }
);

InstructionDestination.displayName = 'InstructionDestination';
